import { Modal, ModalProps, modalHoc } from '@innowise-group/mui-kit';
import { useTranslation } from 'react-i18next';
import * as Styled from './transfer-referral-payment';
import { Input } from '@innowise-group/mui-kit';
import { useState } from 'react';
import { TransferReferralPaymentModalProps } from './transfer-referral-payment.types';

const COMMENT_MAX_SIZE = 500;

const TransferReferralPaymentModal: React.FC<ModalProps & TransferReferralPaymentModalProps> = ({
  title,
  titleParams,
  description,
  confirmationText,
  close,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const [comment, setComment] = useState<string | null>(null);

  const trimmedComment = (comment || '').trim();
  const isCommentEmpty = trimmedComment.length === 0;
  const isDirtyField = typeof comment === 'string' && isCommentEmpty;
  const isCommentTooMatch = trimmedComment.length > COMMENT_MAX_SIZE;
  const isSubmitButtonDisabled = isCommentTooMatch || isCommentEmpty;

  const onCloseHandler = () => close();
  const handleSubmit = () => onSubmit(trimmedComment);
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => setComment(event.currentTarget.value);

  return (
    <Modal.Container size="small">
      <Modal.Header onClose={onCloseHandler}>
        <Styled.Header>{t(title, titleParams)}</Styled.Header>
      </Modal.Header>
      <Modal.Body>
        <Styled.Description>{t(description)}</Styled.Description>

        <Input
          rows={6}
          multiline
          onChange={handleChange}
          label={t('common.labels.comment')}
          required
          error={isCommentTooMatch || isDirtyField}
          helperText={isCommentTooMatch ? t('errors.characterLimit') : isDirtyField ? t('errors.requiredField') : ''}
        />
      </Modal.Body>
      <Modal.Actions
        noVerticalPadding={true}
        position={'full'}
        actions={[
          {
            title: t('buttons.cancel'),
            onClick: onCloseHandler,
            type: 'button',
          },
          {
            title: t(confirmationText),
            onClick: handleSubmit,
            type: 'button',
            highlighted: true,
            disabled: isSubmitButtonDisabled,
          },
        ]}
      />
    </Modal.Container>
  );
};

export default modalHoc(TransferReferralPaymentModal, 'transfer-referral-payment');
